import { Namespace, useTypedT } from "@racoon/i18n";
import { CardContentWrapper } from "~/ui/components/cardContent.wrapper";
import { SoonBadge } from "./soon-badge";

// No backend endpoint exists for gas-analyzer violations yet — mock rows
// matching the Figma reference, shown until the API is available. The list
// below is a short illustrative sample; the real feed would scroll further.
const MOCK_VIOLATION_COUNT = 14;
const MOCK_VIOLATIONS = [
  { plateNumber: "381BCJ02", organizationName: "ТОО Ак Тартып", time: "12:54", date: "21.08.26" },
  { plateNumber: "223ОCJ01", organizationName: "Неизвестно", time: "12:54", date: "21.08.26" },
  { plateNumber: "381BCJ02", organizationName: "ТОО Ак Тартып", time: "12:54", date: "21.08.26" },
  { plateNumber: "381BCJ02", organizationName: "ТОО Ак Тартып", time: "12:54", date: "21.08.26" },
];

export const GasAnalyzerPanel = ({ periodLabel }: { periodLabel: string }) => {
  const t = useTypedT(Namespace.Govdash);

  return (
    <CardContentWrapper hasDivider={false} className="flex min-w-0 flex-col flex-1 overflow-hidden">
      <div className="flex shrink-0 items-center gap-2 border-b border-slate-200 p-4">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div className="flex min-w-0 items-center gap-2">
            <p className="min-w-0 truncate text-base font-semibold text-text-primary">
              {t("monitor.gasAnalyzerPanelTitle")}
            </p>
            <SoonBadge />
          </div>
          <p className="text-sm font-medium text-text-secondary">{periodLabel}</p>
        </div>
        {/* TODO: remove blur once feature is implemented */}
        <p className="shrink-0 text-[22px] font-bold leading-7 tracking-tight text-error blur-sm">
          {MOCK_VIOLATION_COUNT}
        </p>
      </div>
      {/* TODO: remove blur once feature is implemented */}
      <div className="flex min-h-0 flex-1 flex-col gap-2 overflow-y-auto p-4 blur-sm">
        {MOCK_VIOLATIONS.map((violation, index) => (
          <div key={index} className="flex items-center justify-between gap-2">
            <span className="shrink-0 whitespace-nowrap rounded border border-text-primary px-1 py-1 text-xs font-medium text-text-primary">
              {violation.plateNumber}
            </span>
            <p className="min-w-0 truncate text-sm font-medium text-text-secondary">
              {violation.organizationName}
            </p>
            <div className="flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-text-secondary">
              <span>{violation.time}</span>
              <span>{violation.date}</span>
            </div>
          </div>
        ))}
      </div>
    </CardContentWrapper>
  );
};
